import { CommandBase } from "../CommandBase.js";

export class LsCommand extends CommandBase {
    async execute(args) {
        const pathArg = args[0];
        const targetPath = this.fileSystem.resolvePath(pathArg);
        const dirNode = this.fileSystem.getNode(targetPath);

        if (!dirNode) {
            this.write(`ls: cannot access '${pathArg || '.'}': No such file or directory`, 'text-danger');
            return;
        }
        if (dirNode.type !== 'dir') {
            this.write(pathArg || targetPath.split('/').pop(), 'text-primary');
            return;
        }

        const children = dirNode.children.sort();
        if (children.length === 0) return;

        const firstChildPath = (targetPath === '/' ? '/' : targetPath + '/') + children[0];
        const firstChildNode = this.fileSystem.getNode(firstChildPath);
        const kind = firstChildNode?.meta?.kind;

        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);

        if (kind === 'project' || kind === 'blog') {
            await this.renderTable(children, targetPath, kind);
        } else {
            await this.renderStandard(children, targetPath);
        }

        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);
    }

    // In LsCommand.js -> renderTable

    async renderTable(items, currentPath, type) {
        // Name (Title) | File (Slug) | Status
        const gridStyle = "display: grid; grid-template-columns: 200px 1fr 100px; gap: 1rem; align-items: center;";

        let html = `
        <div style="${gridStyle} border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 4px; margin-bottom: 0.5rem;">
            <span class="text-muted">NAME</span>
            <span class="text-muted">FILE (TYPE THIS)</span>
            <span class="text-muted">STATUS</span>
        </div>`;

        items.forEach(child => {
            const fullPath = (currentPath === '/' ? '/' : currentPath + '/') + child;
            const node = this.fileSystem.getNode(fullPath);
            const meta = node.meta || {};
            
            // 'child' is the filename (slug)
            const title = meta.title || child;

            let colorClass = 'text-primary';
            if (type === 'project') {
                if (meta.status === 'active') colorClass = 'text-success';
                else if (meta.status === 'in-progress') colorClass = 'text-warning';
            } else {
                colorClass = 'text-accent'; 
            }

            // Using white for the slug so it pops
            html += `
            <div style="${gridStyle} margin-bottom: 4px;">
                <span class="text-muted-dim" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${title}</span>
                <span class="${colorClass}">${child}</span>
                <span class="text-muted small">[${(meta.status || meta.date || 'N/A').toUpperCase()}]</span>
            </div>`;
        });

        this.writeHTML(html);
    }

    async renderStandard(items, currentPath) {
        let output = `<div class="terminal-grid-container">`;
        
        items.forEach(child => {
            const fullPath = (currentPath === '/' ? '/' : currentPath + '/') + child;
            const node = this.fileSystem.getNode(fullPath);
            
            let className = 'text-primary'; 
            if (node?.type === 'dir') className = 'text-accent';
            else if (node?.meta?.kind === 'project') className = 'text-success';
            else if (node?.meta?.kind === 'blog') className = 'text-warning';
            else if (child.startsWith('.')) className = 'text-muted'; 

            output += `<span class="terminal-grid-item ${className}" style="display:inline-block; margin-right:2rem;">${child}</span>`;
        });
        
        output += `</div>`;
        this.writeHTML(output);
    }
}